import { Theme } from "@mui/material";

export const useGlobalStyles = (theme: Theme) => {
    const scrollbarSize = 11;

    return {
        '*::-webkit-scrollbar': {
            width: `${scrollbarSize}px`,
            height: `${scrollbarSize}px`,
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[500],
            borderRadius: `${scrollbarSize / 2}px`,
        },
        '*::-webkit-scrollbar-thumb:hover': {
            backgroundColor: theme.palette.primary.main,
        },
        '*::-webkit-scrollbar-track': {
            backgroundColor: theme.palette.grey[200],
        },
        '@media (max-width: 600px)': {
            '*::-webkit-scrollbar': {
                display: 'none',
            },
            '*': {
                'scrollbarWidth': 'none', /* Firefox */
            },
        },
        ".MuiPickersPopper-root": {
            zIndex: `${theme.zIndex.drawer * 4} !important`,
        },
        ".MuiPopover-root": {
            zIndex: `${theme.zIndex.drawer * 4} !important`,
        }
    };
}